module.exports = __webpack_public_path__ + "static/media/aktam.8523a504.png";